import axios from 'axios';
import router from '../router';
import Mint from 'mint-ui';
import cookie from 'js-cookie';
import global from './global';// 引用文件


// axios默认配置设置
// axios.defaults.timeout = 100000;
axios.defaults.baseURL = global.postUrl;
// axios.defaults.baseURI = '/api';

axios.defaults.withCredentials = true; // 允许发送cookie给后台

// http request 请求拦截器
axios.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);
    config.headers.common['Authorization'] = cookie.get('auth');
    Mint.Indicator.open({
      text: '請稍候',
      spinnerType: 'snake'
    })
    return config
  },
  error => {
    return Promise.reject(error);
  }
)
// 响应拦截器
axios.interceptors.response.use(
  response => {
    Mint.Indicator.close();
    let status = response.status;
    if (status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    Mint.Indicator.close();
    if (error.response.status) {
      let status = error.response.status;
      switch (status) {
        case 300:
          console.log(error);
          break;
        case 400:
          Mint.Toast({message: error.response.data.error});
          break;
        case 401:
          // Mint.Toast({message: error.response.data.error});
          setTimeout(() => {
            router.push({path: '/login'})
          }, 1500);
          break;
        case 403:
          Mint.Toast({message: error.response.data.error});
          break;
        case 404:
          Mint.Toast({message: '请求的内容不存在，请重试'});
          break;
        case 418:
          Mint.Toast({message: '登录状态失效，请登录',duration: 500});
          localStorage.clear();
          cookie.remove('auth');
          router.replace('login');
          break;
        case 500:
          Mint.Toast({message: error.response.data.error});
          break;
        default:
          Mint.Toast({message: error.response.data.error});
      }
      return Promise.reject(error.response);
    }
  }
)

/**
 * 封装get方法
 * @param url 请求地址
 * @param headers 请求头
 * @param params 请求参数
 * @returns {Promise}
 */

export function get (url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.get(url, params, {
      headers: headers
    })
      .then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      });
  })
}

/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */

export function post (url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: headers
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      });
  })
}

/**
 * 封装del请求
 * @param url
 * @param params
 * @returns {Promise}
 */

export function del (url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.delete(url, params, {
      headers: headers
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      });
  })
}
export function dels (url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      headers: headers,
      data: params
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      });
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (url, param, headers) {
  return new Promise((resolve, reject) => {
    axios.put(url, param, {
      headers: headers
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      });
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch (url, param, headers) {
  return new Promise((resolve, reject) => {
    axios.patch(url, param, {
      headers: headers
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      });
  })
}



// WEBPACK FOOTER //
// ./src/utils/https.js